import {
  getFinancialData as getFinancialDataCall,
  getItemFinancialData as getItemFinancialDataCall,
  getCollectionSizeStats as getCollectionSizeStatsCall,
  getShirtsPerTeamStats as getShirtsPerTeamStatsCall,
  getShirtsPerCompetitionStats as getShirtsPerCompetitionStatsCall,
  getShirtsPerCountryStats as getShirtsPerCountryStatsCall,
  getShirtsPerTypeStats as getShirtsPerTypeStatsCall,
  getShirtsPerSeasonStats as getShirtsPerSeasonStatsCall,
  getShirtsPerDecadeStats as getShirtsPerDecadeStatsCall,
  getShirtsWornInMatchCount as getShirtsWornInMatchCountCall,
} from "./api/statsService";
import NotificationService from "../components/Notification/notificationService";
import LoginService from "./loginService";
import {
  CollectionSizeElement,
  FinancialElement,
  FinancialItemElement,
  ShirtsCountryCountElement,
  ShirtsDecadeCountElement,
  ShirtsNameCountElement,
  ShirtsSeasonCountElement,
} from "./shirts/types";

export default function StatsService() {
  const { error: errorNotification } = NotificationService();
  const { setLogout } = LoginService();

  const handleError = (status: number, description: string) => {
    if (status === 401) {
      setLogout();
    } else {
      errorNotification(description);
    }
  };

  const getFinancialData = async (userId: number) => {
    let response = await getFinancialDataCall(userId).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });

    if (response?.data) {
      let financialElements: Array<FinancialElement> = response.data.data;

      financialElements.sort((a, b) => {
        if (a.year === b.year) {
          return b.month - a.month;
        }
        return b.year - a.year;
      });

      return financialElements.length > 0 ? financialElements[0] : undefined;
    } else {
      return undefined;
    }
  };

  const getFinancialStats = async (userId: number) => {
    let response = await getFinancialDataCall(userId).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });

    if (response?.data) {
      let financialElements: Array<FinancialElement> = response.data.data;

      financialElements.sort((a, b) => {
        if (a.year === b.year) {
          return a.month - b.month;
        }
        return a.year - b.year;
      });

      return financialElements;
    } else {
      return undefined;
    }
  };

  const getItemFinancialStats = async (itemId: number) => {
    let response = await getItemFinancialDataCall(itemId).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );

    if (response?.data) {
      let financialElements: Array<FinancialItemElement> = response.data.data;

      financialElements.sort((a, b) => {
        if (a.year === b.year) {
          return a.month - b.month;
        }
        return a.year - b.year;
      });

      return financialElements;
    } else {
      return undefined;
    }
  };

  const getCollectionSizeStats = async (itemId: number) => {
    let response = await getCollectionSizeStatsCall(itemId).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );
    if (response?.data) {
      let numericalElements: Array<CollectionSizeElement> = response.data.data;

      numericalElements.sort((a, b) => {
        return parseInt(a.year) - parseInt(b.year);
      });

      return numericalElements;
    } else {
      return undefined;
    }
  };

  const getShirtsPerTeamStats = async (itemId: number) => {
    let response = await getShirtsPerTeamStatsCall(itemId).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );
    if (response?.data) {
      let numericalElements: Array<ShirtsNameCountElement> = response.data.data;

      return numericalElements;
    } else {
      return undefined;
    }
  };

  const getShirtsPerCompetitionStats = async (itemId: number) => {
    let response = await getShirtsPerCompetitionStatsCall(itemId).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );
    if (response?.data) {
      let numericalElements: Array<ShirtsNameCountElement> = response.data.data;

      return numericalElements;
    } else {
      return undefined;
    }
  };

  const getShirtsPerCountryStats = async (itemId: number) => {
    let response = await getShirtsPerCountryStatsCall(itemId).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );
    if (response?.data) {
      let numericalElements: Array<ShirtsCountryCountElement> =
        response.data.data;

      return numericalElements;
    } else {
      return undefined;
    }
  };

  const getShirtsPerTypeStats = async (itemId: number) => {
    let response = await getShirtsPerTypeStatsCall(itemId).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );
    if (response?.data) {
      let numericalElements: Array<ShirtsNameCountElement> = response.data.data;

      return numericalElements;
    } else {
      return undefined;
    }
  };

  const getShirtsPerSeasonStats = async (itemId: number) => {
    let response = await getShirtsPerSeasonStatsCall(itemId).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );
    if (response?.data) {
      let numericalElements: Array<ShirtsSeasonCountElement> =
        response.data.data;

      numericalElements.sort((a, b) => {
        return a.id - b.id;
      });

      return numericalElements;
    } else {
      return undefined;
    }
  };

  const getShirtsPerDecadeStats = async (itemId: number) => {
    let response = await getShirtsPerDecadeStatsCall(itemId).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );
    if (response?.data) {
      let numericalElements: Array<ShirtsDecadeCountElement> =
        response.data.data;

      numericalElements.sort((a, b) => {
        return parseInt(a.decade) - parseInt(b.decade);
      });

      return numericalElements;
    } else {
      return undefined;
    }
  };

  const getShirtsWornInMatchCount = async () => {
    let response = await getShirtsWornInMatchCountCall().catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );
    if (response?.data) {
      return response.data.count;
    } else {
      return undefined;
    }
  };

  return {
    getFinancialData,
    getFinancialStats,
    getItemFinancialStats,
    getCollectionSizeStats,
    getShirtsPerTeamStats,
    getShirtsPerCompetitionStats,
    getShirtsPerCountryStats,
    getShirtsPerTypeStats,
    getShirtsPerSeasonStats,
    getShirtsPerDecadeStats,
    getShirtsWornInMatchCount,
  };
}
